var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"opacity"}},[(_vm.visible)?_c('div',{staticClass:"dialog-overlay-loading",style:({zIndex: _vm.zIndex})},[_vm._v(" Loading… ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }